export { default as Duet } from './Duet'
export { default as FullBleed } from './FullBleed'
export { default as Quartet } from './Quartet'
export { default as Solo } from './Solo'
export { default as Trio } from './Trio'
export { default as TrioWithLead } from './TrioWithLead'



// WEBPACK FOOTER //
// ./src/components/layout/index.js